// extracted by mini-css-extract-plugin
export default {"price":"Price_price__8A3B7","shimmer":"Price_shimmer__4oTME"};